import { useIsDarkMode } from '@psl/appComponents/UserInterfaceIdiomContext';
import { SvgProps } from 'react-native-svg';
import { useResponsiveContext } from '../../functions/responsive/ResponsiveContext';
import { SvgIconProps } from './types';

export function useSvgProps(
  { width, height, size, ...props }: SvgIconProps,
  defaultWidth: number,
  defaultHeight?: number,
) {
  const { rpx } = useResponsiveContext();
  width = width ?? size ?? rpx(defaultWidth);
  height = height ?? size ?? rpx(defaultHeight ?? defaultWidth);
  return {
    width,
    height,
    ...props,
  } as SvgProps;
}

export function useSvgPropsWithDefaultFill(
  { width, height, size, fill, ...props }: SvgIconProps,
  defaultWidth: number,
  defaultHeight?: number,
) {
  const { rpx } = useResponsiveContext();
  const isDarkMode = useIsDarkMode();
  width = width ?? size ?? rpx(defaultWidth);
  height = height ?? size ?? rpx(defaultHeight ?? defaultWidth);
  return {
    width,
    height,
    fill: fill ?? (isDarkMode ? 'white' : 'black'),
    ...props,
  } as SvgProps;
}
